<modal-layout [modalTitle]="'Collection branch' | translate">
    <!-- content -->
    <div modalBody>
        <branch-finder class="block p-b"
                       (onBranchChange)="handleBranchChange($event)"
                       [product]="modalData?.product"></branch-finder>
    </div>
    <!-- bottom part -->
    <!--   <div modalFooter>
 <button class="w-12"
                (click)="confirm()"
                [status]="status"
                [disabled]="!selectedBranchNumber"
                [buttonStyle]>{{'CONFIRM' | translate}}</button>
        <result class="p-t block"
                [status]="status"></result>
    </div>-->
</modal-layout>
